import { zodResolver } from '@hookform/resolvers/zod';
import { Search } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { FormGroup } from '@/components/FormGroup';
import { Input } from '@/components/ui/Input';
import { useDebounce } from '@/hooks/useDebounce';
import { Platform, Status } from '@/services/CustomerService';

const searchSchema = z.object({
  searchValue: z.string(),
});

type SearchFormData = z.infer<typeof searchSchema>;

interface Filters {
  searchTerm: string | null;
  platform: Platform | null;
  status: Status | null;
}

interface SearchCustomersFormProps {
  onSearchChange: (partial: Partial<Filters>) => void;
  onPageChange: (page: number) => void;
}

export function SearchCustomersForm({
  onSearchChange,
  onPageChange,
}: SearchCustomersFormProps) {
  const { register, watch } = useForm<SearchFormData>({
    resolver: zodResolver(searchSchema),
    defaultValues: {
      searchValue: '',
    },
  });

  const watchedSearchValue = watch('searchValue');
  const searchValueDebounced = useDebounce(watchedSearchValue, 500);

  const onSearchChangeRef = useRef(onSearchChange);
  onSearchChangeRef.current = onSearchChange;

  useEffect(() => {
    const searchTerm = searchValueDebounced.trim() || null;
    onSearchChangeRef.current({ searchTerm });
    onPageChange(1);
  }, [searchValueDebounced, onSearchChangeRef, onPageChange]);

  return (
    <div>
      <div className="relative flex-1">
        <FormGroup>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              id="searchValue"
              className="w-full bg-white pl-10 pr-4"
              placeholder="Search customers by name or ID..."
              {...register('searchValue')}
            />
          </div>
        </FormGroup>
      </div>
    </div>
  );
}
